// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"Loading_loadingWrapper__MDAYK"};